import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RlpComponent } from './rlp.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IdsModule } from '../../ids.module';
import { LoadingCircleModule } from './../../shared/component/common/loading-circle/loading-circle.module';
import { ButtonModule } from '../../shared/component/common/button/button.module';
@NgModule({
  declarations: [RlpComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ButtonModule,
    ReactiveFormsModule,
    IdsModule,
    LoadingCircleModule
  ]
})
export class RlpComponentModule { }
